<template>
  <div class="triangle" :style="customStyle"></div>
</template>

<script>
  export default {
    name: 'triangle-component',
    props: {
      topColor: { type: String },
      rightColor: { type: String },
      bottomColor: { type: String },
      leftColor: { type: String }
    },
    data: function () {
      return {
        currentWidth: 0,
        triangleHeight: 0,
        customStyle: ''
      }
    },
    mounted() {
      this.currentWidth = document.body.clientWidth
      this.triangleHeight = parseInt(220 / 1920 * this.currentWidth)
      this.customStyle = this.getCustomStyle()
    },
    methods: {
      getCustomStyle() {
        if (this.topColor && this.rightColor) {
          return {
            'border-top': this.triangleHeight + 'px solid ' + this.topColor,
            'border-right': this.currentWidth + 'px solid ' + this.rightColor
          }
        }
        if (this.topColor && this.leftColor) {
          return {
            'border-top': this.triangleHeight + 'px solid ' + this.topColor,
            'border-left': this.currentWidth + 'px solid ' + this.leftColor
          }
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .triangle-top-right {
    width: 0;
    height: 0;
  }
</style>




// WEBPACK FOOTER //
// Triangle.vue?012e5cef